import axios from 'axios';

import { ReportQueue, GetBaseQueueOptions } from 'components/types';

import { REPORT_QUEUE } from '../endpoints';

export const getReportQueue = ({ params, signal }: GetBaseQueueOptions) =>
  axios.get<ReportQueue>(REPORT_QUEUE, {
    signal,
    params
  });
